import { Spin } from 'antd';
import { WinkSmile, Sad } from '@styled-icons/boxicons-regular';
import Text from '@/shared/Typography/Text';
import Title from '@/shared/Typography/Title';
import Result from '@/shared/Result/Result';
import Button from '@/shared/Button/Button';
import { StyledPaymentResult } from './PaymentResult.styled';
import usePaymentResult from './usePaymentResult.hook';
import merge from 'lodash.merge';

const defaultButtonConfig = {
  success: {
    icon: <WinkSmile height={50} width={50} color="white" />,
    title: 'Congratulations!',
    subTitle:
      'You will recevice an email with all the details about the purchase',
    buttonText: 'Enjoy Rockalingua',
  },
  error: {
    icon: <Sad height={50} width={50} color="white" />,
    title: 'There was an error!',
    subTitle:
      'Something went wrong with the payment, please try it again or contact us',
    buttonText: 'Try again',
  },
};

export default function PaymentResult({
  onSuccess,
  onError,
  buttonConfig = {},
}) {
  const { state } = usePaymentResult();

  if (state.loading) {
    return (
      <StyledPaymentResult>
        <h3 className="mb">
          We are waiting for the transaction to be processed...
        </h3>
        <Spin spinning />
      </StyledPaymentResult>
    );
  }

  const config = merge({}, defaultButtonConfig, buttonConfig);
  const { icon, title, subTitle, buttonText } = config[state.status];
  const buttonAction = state.status == 'success' ? onSuccess : onError;

  return (
    <StyledPaymentResult>
      <Result
        icon={icon}
        status={state.status}
        title={
          <Title level={1} color="white">
            {title}
          </Title>
        }
        subTitle={
          <Text color="white" strong>
            {subTitle}
          </Text>
        }
        extra={
          <Button type={state.status} onClick={buttonAction}>
            {buttonText}
          </Button>
        }
      />
    </StyledPaymentResult>
  );
}
